import * as React from "react";
import Map from "src/share/components/Maps/Map/Map";
import { initialGeoSearchState } from "src/share/types/geoSearch";

const formatRadius = (radius) => (typeof radius === "string" ? `${radius} miles.` : radius);

const GSResultsInformation = ({ results, faces, matches, center, from, to, radius, loading }) => {
  return (
    <div>
      <h2>Results Information</h2>
      <div className="geosearch-result__results-info">
        <div className="geosearch-result__results">
          <h5>Number of results:</h5>
          <p>{results}</p>
        </div>
        <div className="geosearch-result__faces">
          <h5>Faces found:</h5>
          <p>{faces}</p>
        </div>
        <div className="geosearch-result__matches">
          <h5>Matches Found:</h5>
          <p>{matches}</p>
        </div>
        <div className="geosearch-result__selected-date">
          <h5>Selected Date:</h5>
          <p>
            From: {from} <br />
            To: {to}
          </p>
        </div>
        <div className="geosearch-result__radius">
          <h5>Radius:</h5>
          <p>{formatRadius(radius)} {radius <= 1 ? 'Mile' : 'Miles'}</p>
        </div>
        <div className="geosearch-result__map">
          <Map
            radius={loading ? 0 : radius}
            center={loading ? initialGeoSearchState.selectedLocation : center}
            isLocationSelected={true}
            isMapDisabled={true}
          />
        </div>
      </div>
    </div>
  );
};

export default GSResultsInformation;
